import { useEffect, useState } from "react";
import SidebarLayout from "./SidebarLayout";
import TopbarLayout from "./TopbarLayout";
import { Auth } from "../../utils/Auth";
import { useNavigate } from "react-router-dom";
import { authApi } from "../../api/authApi";
import { message } from "antd";

const MainLayout = (props) => {
  const abortController = new AbortController()
  const navigate = useNavigate()
  useEffect(() => {
    console.log("token",Auth.getSessionToken())
    console.log("Admin",Auth.getUser())

      if(!Auth.isLoggedIn() || !Auth.getSessionToken()){
          Auth.removeSessionToken()
          navigate('/login');
      }            
  },[navigate])


    const [sidebarOpen, setSidebarOpen] = useState(false);
    // const handleLogout = async () =>  {
      
    //   const res = await authApi.logout({},abortController.signal)

    //   console.log(res)
    // }

    // const abortController = new AbortController()
  // const navigate = useNavigate()

  const  handleLogout =  () => {
    // const res = await authApi.logout({},abortController.signal)
    Auth.removeSessionToken()
    message.success("Deconnexion effectue")

    return navigate('/login')

    // console.log(res)
    // if (!res.success) {
    //   return message.error("Deconnexion impossible")
    // }else{
      
    // }

    

  }

    return (
        <div className="flex h-screen bg-gray-100">
          {/* Sidebar */}
          <SidebarLayout sidebarOpen={sidebarOpen}  className="fixed top-0 left-0 w-64 h-full bg-white shadow-lg z-10"></SidebarLayout>
          
    
          {/* Content area */}
          <div className="flex flex-col flex-1">
            {/* Top Bar */}
            <TopbarLayout setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} handleLogout={handleLogout}></TopbarLayout>            
    
            {/* Main Content */}
            <main className="flex-1 p-6 overflow-auto">
              {props.children}
            </main>
          </div>
        </div>
      );
}

export default MainLayout